import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MarketplaceButtonAction, MarketplaceButtonActionPayload } from './marketplace-button.action';
import { inject } from '@angular/core';
import { MarketplacePurchaseConfirmationV2Component } from '../marketplace-purchase-confirmation-v2/marketplace-purchase-confirmation-v2.component';

/**
 * Action for redeem button in marketplace details. This action will open a confirmation modal for the user to confirm their purchase.
 * It will pass the selected item, attributes, quantity, and custom fields to the modal component for display and processing of the purchase.
 */
export class RedeemModalButtonAction extends MarketplaceButtonAction {
  invoke(payload: MarketplaceButtonActionPayload): void {
    const modalService = inject(NgbModal);
    const { item, quantity, attribute, customFields } = payload;

    const modal = modalService.open(MarketplacePurchaseConfirmationV2Component, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      windowClass: 'reward-confirm-modal',
    });
    modal.componentInstance.templateSelected = 'confirmContent';
    modal.componentInstance.marketplaceItem = item;
    modal.componentInstance.selectedAttribute = attribute;
    modal.componentInstance.purchaseQuantity = quantity;
    modal.componentInstance.validCustomFields = customFields;
  }
}
